import React from 'react';

import Card from './card';


export default function TableCard(props) {
  return (
    <Card {...props} defaultClasses="table-card" />
  );
}



// WEBPACK FOOTER //
// ./app/components/content-containers/cards/table-card.js